import { useState } from "react";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";
import DSCard from "views/system-design/DSCard";
import DSCardContent from "views/system-design/DSCardContent";
import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import DSCircularProgress from "views/system-design/DSCircularProgress";
import DSCheckbox from "views/system-design/DSCheckBox";
import DSFormControlLabel from "views/system-design/DSFormControlLabel";
import useClocksWithCollectionCount from "components/hooks/useClocksWithCollectionCount";

const DAILY_RHYTHM_COLLECTION_ID = "6a01cbbdff124e99458fa150";

const flatCardSx = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "surface.card",
  backgroundImage: "none",
  borderRadius: "20px",
} as const;

function DailyRhythmCollectionWidget() {
  const [betaOnly, setBetaOnly] = useState(false);
  const { data, isLoading, error } = useClocksWithCollectionCount(
    DAILY_RHYTHM_COLLECTION_ID,
    betaOnly,
  );

  return (
    <DSCard sx={flatCardSx}>
      <DSCardContent sx={{ flex: 1 }}>
        <DSBox
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 1,
            mb: 1,
          }}
        >
          <DSBox sx={{ typography: "body2", color: "text.secondary" }}>
            DailyRhythm Collection
          </DSBox>
          <DSBox
            sx={{
              color: "surface.accentText",
              "& svg": { fontSize: "1.5rem" },
              display: "flex",
            }}
          >
            <RepeatOutlinedIcon />
          </DSBox>
        </DSBox>
        <DSBox sx={{ typography: "h6", fontFamily: "Gilroy-Bold" }}>
          {isLoading ? (
            <DSCircularProgress size={20} />
          ) : error ? (
            <DSTypography variant="body2" sx={{ color: "error.main" }}>
              Failed to load
            </DSTypography>
          ) : (
            (data?.count ?? 0).toLocaleString()
          )}
        </DSBox>
        <DSTypography
          variant="body2"
          sx={{ color: "text.secondary", mt: 0.5, fontSize: 12 }}
        >
          {betaOnly ? "Beta clocks" : "Non-dev clocks"} with this collection
        </DSTypography>
        <DSFormControlLabel
          sx={{ mt: 1, fontSize: 12 }}
          control={
            <DSCheckbox
              size="small"
              checked={betaOnly}
              onChange={(e) => setBetaOnly(e.target.checked)}
            />
          }
          label={
            <DSTypography variant="body2" sx={{ fontSize: 12 }}>
              Beta clocks only
            </DSTypography>
          }
        />
      </DSCardContent>
    </DSCard>
  );
}

export default DailyRhythmCollectionWidget;
